import React from "react";
import getTextColor from "./DynamicContrast";
import { lightTheme, darkTheme } from "../utils/Themes";
import { Link } from "react-router-dom";
import { getRallyTeamName } from "./General";

const teamLogo = (
  team_id: string | number | null,
  logo: string | null | undefined,
  team_name: string,
) => {
  if (team_id == null || team_id == "-1") {
    const logo_string = logo != null && logo != "" ? "_" + logo : "";
    console.log(`/assets/Teams/General/${team_name}${logo_string}.png`);
    return (
      <img
        className="full-width"
        src={`/assets/Teams/General/${team_name}${logo_string}.png`}
        onError={(e: any) => {
          e.target.src = require("../assets/Images/Unknown.png");
        }}
        alt={team_name}
      />
    );
  } else if (!Number.isNaN(Number(team_id))) {
    const logo_string = logo != null ? "_" + logo : "";
    return (
      <img
        className="full-width"
        src={`/assets/Teams/${team_id}${logo_string}.png`}
        alt={team_name}
      />
    );
  } else if (team_name === "LigaVirtualF1 Team") {
    return (
      <img
        className="full-width"
        src={require(`../assets/Images/Logo.png`)}
        alt={team_name}
      />
    );
  } else {
    return (
      <img
        className="full-width"
        src={require(`../assets/Images/Unknown.png`)}
        alt={team_name}
      />
    );
  }
};

const teamBackground = (team_id: string | null, main_color: string | null) => {
  if (team_id === "LigaVirtualF1 Team") return "#3bd8c9";
  else if (main_color == null) return "";
  else return main_color;
};

const getColor = (team_id: string | null, main_color: string | null) => {
  if (main_color == "") main_color = null;
  if (team_id === "LigaVirtualF1 Team") return "black";
  else if (main_color === null && (team_id == null || team_id == "-1"))
    return "";
  else if (main_color !== null) return getTextColor(main_color);
  return "";
};

const getStandingsPositionStyle = (position: number | string) => {
  if (!Number.isNaN(Number(position))) {
    position = parseInt(position.toString());
  }
  if (position === 1) return "standings-WINNER";
  else if (position === 2) return "standings-SECOND";
  else if (position === 3) return "standings-THIRD";
  else if (position === "Ret") return "standings-Ret";
  else if (position === "DSQ" || position === "DQ") return "standings-DSQ";
  else if (position === "DNQ") return "standings-DNQ";
};

const getStandingsPositionColor = (
  position: number | string,
  theme_: string,
) => {
  const theme = theme_ === "light" ? lightTheme : darkTheme;
  if (!Number.isNaN(Number(position))) {
    position = parseInt(position.toString());
  }
  if (position === 1) return theme.winnerColor;
  else if (position === 2) return theme.secondColor;
  else if (position === 3) return theme.thirdColor;
  else if (position === "Ret") return theme.retColor;
  else if (position === "DSQ" || position === "DQ") return theme.dnqColor;
  else if (position === "DNQ") return theme.dnqColor;
  else if (position === "DNS") return theme.othersColor;
  else return theme.pointsColor;
};

const getAbbreviation = (driver: string) => {
  const words = driver.trim().split(/\s+/);
  if (words.length === 1) {
    const word = words[0];
    const match = word.match(/[A-Z][a-z]*/g);
    if (match && match.length > 1) {
      const hasShortPart = match.some((parte) => parte.length < 3);

      if (hasShortPart || match[1].length === 1) return word;

      return match
        .map((parte, idx) => (idx === 0 ? parte[0] : parte))
        .join(" ");
    }
    return word;
  } else if (words.length === 2) {
    const [name, surname] = words;
    return surname.length < 3 || name.length < 3
      ? name + " " + surname
      : name[0] + " " + surname;
  } else {
    const initials = words
      .slice(0, -1)
      .map((word) => word[0])
      .join("");
    return `${initials} ${words.at(-1)}`;
  }
};

const getDriverNameLink = (driver: DriverStanding | DriverStats, t: any) => {
  let nickname = driver.username;
  if (driver.username == null) nickname = "TBA";
  //external championship
  if (driver.flag_code === null)
    return (
      <label
        className="full-white-driver"
        style={{
          color: getColor(driver.team_id, driver.main_color),
        }}
        data-full-name={nickname}
        data-last-name={getAbbreviation(nickname)}
      ></label>
    );
  return (
    <Link
      className="full-white-driver"
      to={`${t("routes:Driver")}/${encodeURIComponent(nickname)}`}
      style={{
        color: getColor(driver.team_id, driver.main_color),
      }}
      data-full-name={nickname}
      data-last-name={getAbbreviation(nickname)}
    ></Link>
  );
};

const getSeasonTeamFormat = (
  summary: DriverSummary,
  index_parent: number,
  t: any,
) => {
  let teams_JSX;
  if (summary.hasOwnProperty("teams_array")) {
    teams_JSX = summary.teams_array?.map((team, index) => {
      return (
        <div
          key={`${index}-${index_parent}`}
          className="teamdriver-results-container text-left"
          style={{
            background: teamBackground(team.id, team.main_color),
            color: getColor(
              team.id == null ? null : team.id.toString(),
              team.main_color,
            ),
          }}
        >
          <div className="logo-results-container flex-center">
            {teamLogo(team.id, team.logo, team.name)}
          </div>
          {team.id == null ? (
            <label>{team.name}</label>
          ) : (
            <Link
              className="full-white-driver"
              to={`${t("routes:Team")}/${encodeURIComponent(team.name)}`}
              style={{
                color: getColor(
                  team.id == null ? null : team.id.toString(),
                  team.main_color,
                ),
              }}
            >
              {team.name}
            </Link>
          )}
        </div>
      );
    });
  }
  //Case First HCs or Rally with no teams
  else if (summary.teams_id == null && summary.main_colors != null) {
    console.log(summary);
    teams_JSX = (
      <div
        key={`N-${index_parent}`}
        className={`${
          summary.name === "EVENTS" ? "events-team" : ""
        } teamdriver-results-container text-left`}
        style={{
          background: summary.main_colors,
        }}
      >
        {summary.teams != null && (
          <div className="logo-results-container flex-center">
            {teamLogo(null, summary.logos, summary.teams.split(" ")[0])}
          </div>
        )}
        <div className="logo-results-container flex-center"></div>
        <label className="full-white-driver">
          <label
            className="full-white-driver"
            style={{
              color: getColor(summary.teams, summary.main_colors),
            }}
          >
            {getRallyTeamName(summary.teams, summary.class_name)}
          </label>
        </label>
      </div>
    );
  } else {
    teams_JSX = (
      <div
        key={`N-${index_parent}`}
        className={`${
          summary.name === "EVENTS" ? "events-team" : ""
        } teamdriver-results-container text-left`}
        style={{
          background:
            summary.teams != null || summary.name === "EVENTS" ? "" : "#000000",
        }}
      >
        {summary.teams != null && (
          <div className="logo-results-container flex-center">
            {teamLogo(null, null, summary.teams)}
          </div>
        )}
        <div className="logo-results-container flex-center"></div>
        <label
          className="full-white-driver"
          style={{
            color: summary.teams != null ? "" : "#ffffff",
          }}
        >
          {summary.name === "EVENTS"
            ? t("Events")
            : summary.teams == null
              ? summary.name
              : summary.teams}
          ss
        </label>
      </div>
    );
  }
  return teams_JSX;
};

export {
  teamLogo,
  teamBackground,
  getColor,
  getStandingsPositionStyle,
  getStandingsPositionColor,
  getDriverNameLink,
  getAbbreviation,
  getSeasonTeamFormat,
};
